module.exports = __webpack_public_path__ + "static/media/intro_services.a263af33.svg";